var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 7.83327V2.38322C12.7609 2.67155 13.461 3.11572 14.0543 3.70823L16.9577 6.61326C17.551 7.20576 17.9952 7.90577 18.2835 8.66661H12.8334C12.3734 8.66661 12.0001 8.29244 12.0001 7.83327ZM13.0584 18.2334C12.3809 18.9109 12.0001 19.8292 12.0001 20.7876V22.0001H13.2126C14.171 22.0001 15.0893 21.6192 15.7668 20.9417L21.4394 15.2692C22.1869 14.5217 22.1869 13.3083 21.4394 12.5608C20.6919 11.8133 19.4785 11.8133 18.731 12.5608L13.0584 18.2334ZM10.3334 20.7876C10.3334 19.3776 10.8826 18.0517 11.8793 17.055L17.5518 11.3825C17.876 11.0583 18.2535 10.8091 18.661 10.6316C18.6577 10.5316 18.6535 10.4325 18.6468 10.3325H12.8334C11.4551 10.3325 10.3334 9.21079 10.3334 7.83244V2.01988C10.1993 2.01071 10.0651 1.99988 9.92925 1.99988H6.16671C3.86919 1.99988 2 3.86906 2 6.16659V17.8334C2 20.1309 3.86919 22.0001 6.16671 22.0001H10.3334V20.7876Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.d24bdc0905a50e57d149d9ac1f09360e.svg";
export { ForwardRef as ReactComponent };